module.exports = __webpack_public_path__ + "static/media/09-d-calendar.aa003904.jpg";